/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgManageAllocations = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M18.586 6H16V4h6v6h-2V7.414L15.414 12 20 16.586V14h2v6h-6v-2h2.586l-6-6zM6 7V6h2v1h3v2H8v2h1a3 3 0 1 1 0 6H8v1H6v-1H3v-2h3v-2H5a3 3 0 1 1 0-6zm0 2H5a1 1 0 0 0 0 2h1zm2 4v2h1a1 1 0 1 0 0-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgManageAllocations as ManageAllocations };
